"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDateCell = void 0;
const date_field_1 = require("../../../components/date-field/date-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
exports.FilterDateCell = filter_interval_cell_factory_1.filterIntervalCellFactory(date_field_1.DateField);
//# sourceMappingURL=filter-date-cell.js.map